import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountService } from '../../services/account.service';

@Injectable({
  providedIn: 'root'
})

export class RegistrationLoggedOutGuard implements CanActivate {

  constructor(private accountService: AccountService, private route: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.accountService.currentUser$.pipe(map(user => {
      if (user) {
        this.route.navigate(['/registration/home']);
        return false;
      } else {
        return true;
      }
    }))
  }
}
